import {connect} from '../../app/connect';
import IssuePreviewPanel from './IssuePreviewPanel';
import {selectPushpinAction, deselectPushpinsAction} from '../../app/actions';
import {getCurrentPreviewIssueAttributes, getCurrentSheets, isIssuesBatchLoading} from '../../app/selectors';

const mapStateToProps = state => {
  const issue = getCurrentPreviewIssueAttributes(state);
  const isFetchingIssues = isIssuesBatchLoading(state);

  return {
    issue,
    currentSheets: getCurrentSheets(state),
    isLoadingCollection: isFetchingIssues
  };
};

export default connect(
  mapStateToProps,
  {
    selectPushpinAction,
    deselectPushpinsAction
  }
)(IssuePreviewPanel);
